import React from 'react'
import { Grid } from '@mui/material'
import UserPasswordForm from './UserPasswordForm'
import User2FA from './User2FA'

export default function UserSecurity() {
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            alignContent="center"
        >
            <Grid item xs={12} md={10} lg={8} xl={6}>
                <Grid container rowSpacing={6}>
                    <Grid item xs={12}>
                        <UserPasswordForm />
                    </Grid>
                    <Grid item xs={12}>
                        <User2FA />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
